import script from "./CaseNew.vue?vue&type=script&setup=true&lang=js"
export * from "./CaseNew.vue?vue&type=script&setup=true&lang=js"

import "./CaseNew.vue?vue&type=style&index=0&id=c3ed264a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c3ed264a"]])

export default __exports__